import React, { useEffect, useState } from 'react'
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar'
import Header from '../../Components/Header'
import { Constants } from '../../CommonMethhods/Constants';
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate } from '../../CommonMethhods/CommonMethods';
import axios from 'axios';
import { CLIENT_FNO, Client_Search, Dashboard_Client_Report } from '../../Configuration/API_URL';
import $ from "jquery";
import TodateComponent from '../Reports/TodateComponent';
import FromdateComponent from '../Reports/FromdateComponent';
import LoaderForSearch from '../../Components/Common/LoaderForSearch';
import ClientFnoLossTable from './ClientFnoLossTable';
import { toast } from 'react-toastify';
import moment from 'moment';

export default function ClientFnoLoss(props) {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [clientList, setClientList] = useState([]);
    const [scroll, setScroll] = useState(false);
    const [clientName, setClientName] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [serverError, setServerError] = useState("");
    const [scrollLoader, setScrollLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [errorResp, setErrorResp] = useState("");
    const [nameError, setNameError] = useState("");
    const [gridVal, setGridVal] = useState("");
    const [loader, setLoader] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [clientNameError, setClientNameError] = useState(false);
    const [pageTable,setPageTable]=useState(1)
    const [count,setCount]=useState()
    const [scrollLoaderTable,setScrollLoaderTable]=useState(false)
    const storeToken = localStorage.getItem("ssoToken");

    async function searchApiDetail(e) {
        $(".write-search.clientfno").addClass("show-result scroll-table");
        let payloadValue = {
            keyword: e.toUpperCase(),
            Status: "",
            PageNo: page,
            PageSize: 10,
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getSearchDetail = await axios.post(
                Client_Search.Search_URL,

                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );

            const res = ApiResDecrypt(getSearchDetail?.data);

            if (res.message === "Client does not exist.") {
                setClientList([
                    { clientname: "Client does not exist.", clientCode: null },
                ]);
            } else {
                if (scroll == true) {
                    setClientList((prev) => {
                        return [...prev, ...res.data.clients];
                    });
                    setServerError("");
                } else {
                    setClientList(res.data.clients);
                    setServerError("");
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setScrollLoader(false);
        }
    }
    function clientSet(name, code, i) {
        if (name === "Client does not exist.") {
            setClientCode("")
            $(".write-search.clientfno").addClass("show-result scroll-table");
        } else {
            $(".write-search.clientfno").removeClass("show-result");
            setClientList([]);
            setClientName(name);
            setClientCode(code);
            setScrollLoader(false);
        }
    }

    const handleClientName = (e) => {
        setScrollLoader(false);
        // setFileType("");
        console.log("handle client name", e.target.value)
        if (e.target.value) {
            setClientList([]);
            setScroll(false);
            let result = e.target.value.toUpperCase();
            setClientName(result);
            if (e.target.value.length > 3) {
                setPage(1);
                setClientList([]);
                setScroll(false);
                searchApiDetail(e.target.value);
            }
        } else {
            // setFileType("");
            setClientCode("")
            setClientList([]);
            setPage(1);
            setClientName("");
            setScroll(false);
            $(".write-search.clientfno").removeClass("show-result");
        }
        $(".write-search.clientfno-li").click(function () {
            $(".write-search.clientfno").addClass("show-result scroll-table");
        });
    };
    const handleScroll = async () => {
        setScroll(true);
        const a = document.querySelector("#clientfno-scroll");
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
            setPage((prev) => prev + 1);
            setScrollLoader(true);
            searchApiDetail(clientName);
        }
    };

    const getClientFno = async (fileType, rmCode,pageSize=5,offset) => {
        if (fileType === "grid" && offset > 1) {
            setLoader(false)
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
          }        
       else if (fileType == "excel") {
            setSmallLoaderExcel(true);
            setSmallLoaderPdf(false);
            setLoader(false);
        } else if (fileType == "pdf") {
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(true);
            setLoader(false);
        } else {
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setLoader(true)
        }
        let payloadValue = {
            clientCode: clientCode,
            fromDate: fromDate,
            toDate: toDate,
            rmCode: rmCode,
            fileType: fileType,
            pageSize: pageSize,
            pageNo: offset

        };
        console.log("payload client fno", payloadValue)
        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axios.post(
                CLIENT_FNO.Get_Client_FnO,
                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );
            const res = ApiResDecrypt(getDetails?.data);
            console.log("res client fno", res)
            if (res?.data) {
                if (fileType == "grid") {
                    setCount(res?.data?.totalCount)
                    if (offset > 1) {
                        setGridVal((prev) => {
                          return [...prev, ...res?.data?.fnoLossDetails];
                        })
                      } else {
                        setGridVal(res?.data?.fnoLossDetails);
                      
                      }
                    // setGridVal(res?.data);
                } else if (fileType == "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                } else if (fileType == "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                }

            } else {
                setGridVal([]);
                if (fileType == "excel") {
                    toast.error("Client F&O Report does not exist.");
                } else if (fileType == "pdf") {
                    toast.error("Client F&O Report does not exist.");
                }
            }
            setClientNameError(false);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
        } catch (error) {
            console.log(error);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);

            setServerError("Something went wrong, Please try again later.");
            if (fileType == "excel") {
                toast.error("Something went wrong, Please try again later.");
            }
            if (fileType == "pdf") {
                toast.error("Something went wrong, Please try again later.");
            }

        }
    };

    useEffect(() => {
        getClientFno("grid", "",5,1)
    }, [])

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");

    const handleDownloadBtn = () => {
        getClientFno("excel", "",-1,-1)
    }
    const handleFromDateChange = (e) => {
        if (e.target.value) {
            // setFileType("");
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setFromDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setFromDate("")
            setErrorResp("");
            setServerError("");
        }
    };
    const handleToDateChange = (e) => {
        if (e.target.value) {
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setToDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setToDate("")
            setErrorResp("");
            setServerError("");
        }

    };
    function formatDate(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }

    console.log("from date", fromDate, toDate)
    const handleOnClick = (e) => {
        setPageTable(1)
        console.log("Clicked", e.target.value, fromDate, toDate, clientCode);

        if (clientCode && (!fromDate && !toDate)) {
            getClientFno("grid", "",5,1);
        }
        else if (!clientCode && (fromDate || toDate)) {
            if (compareDate(fromDate) && compareDate(toDate) && checkDateRange(fromDate, toDate)) {
                getClientFno("grid", "",5,1);
            } else {
                setErrorResp("Please enter a valid date range");
            }
        }
        else if (clientCode && (fromDate || toDate)) {
            if (compareDate(fromDate) && compareDate(toDate) && checkDateRange(fromDate, toDate)) {
                getClientFno("grid", "",5,1);
            } else {
                setErrorResp("Please enter a valid date range");
            }
        }
        else if (!clientCode && !fromDate && !toDate) {
            setFromDate("");
            setToDate("");
            setClientCode("");
            getClientFno("grid", "",5,1)
        }
    };
    return (
        <div>
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="main-content" className='client-fno'>
                <div className="card-box">
                    <div className="row input-field-wrapper">
                        <div className="col-md-3 col-sm-3 col-12">
                            <div className="form-group">
                                <label className="form-label">{Constants.Client_Name}</label>
                                <div className="input-text-wrapper align-items-center">
                                    <input
                                        id="input1"
                                        type="text"
                                        className="input-text form-control"
                                        placeholder="Search by Name/ Code"
                                        value={clientName}
                                        onChange={(e) => {
                                            handleClientName(e);
                                        }}
                                    />

                                    <ul
                                        className="write-search clientfno border-0"
                                        id="clientfno-scroll"
                                        onScroll={handleScroll}
                                    >
                                        {clientList.map((item, i) => (
                                            <li
                                                key={i}
                                                onClick={() =>
                                                    clientSet(item.clientname, item.clientCode, i)
                                                }
                                            >
                                                <div> {item.clientname}</div>
                                                <div>{item.clientCode}</div>
                                            </li>
                                        ))}
                                        {scrollLoader && (
                                            <div className="loader-center">
                                                <LoaderForSearch />
                                            </div>
                                        )}
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-6">
                            <FromdateComponent
                                fromDate={handleFromDateChange}
                                formatDate={formatDate(fromDate)}
                                DateReverse={DateReverse}
                                clientWiseReportForCustomCalanderIcon={false}

                            />
                        </div>
                        <div className="col-md-3 col-sm-3 col-6">
                            <TodateComponent
                                toDate={handleToDateChange}
                                formatToDate={formatDate(toDate)}
                                DateReverse={DateReverse}
                                clientWiseReportForCustomCalanderIcon={false}
                                errorResponse={errorResp}
                            />
                        </div>
                    </div>
                    <div className="text-center search-btn-wrapper">
                        <button
                            value="grid"
                            className="send-message"
                            onClick={handleOnClick}
                        >
                            {Constants.Search}
                        </button>
                    </div>
                    <ClientFnoLossTable
                        gridVal={gridVal}
                        smallLoaderExcel={smallLoaderExcel}
                        loader={loader}
                        setLoader={setLoader}
                        setScrollLoaderTable={setScrollLoaderTable}
                        scrollLoaderTable={scrollLoaderTable}
                        count={count}
                        getClientFno={getClientFno}
                        handleDownloadBtn={handleDownloadBtn}
                        setPageTable={setPageTable}
                        pageTable={pageTable} />
                </div>
            </main>

        </div>
    )
}
